module.exports = __webpack_public_path__ + "static/img/gs6.93908c12.jpg";